import { PaletteOptions } from "@mui/material/styles";

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: { main: "#004C9D" },
  secondary: { main: "#00857A" },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: { main: "#017BFF" },
  secondary: { main: "#02968A" },
};
